import React, {ComponentType, ReactElement, ReactNode} from 'react';
import {Alignment} from '../../../types';
import Paragraph from '../../DesignSystem/Text/Paragraph/Paragraph';

import './BusinessStatsItem.scss';

interface Props {
  Icon: ComponentType<{className?: string}>;
  headline: ReactNode | ((className: 'businessStatsItem__stat') => ReactNode);
  description: string;
}

// not documented in story book as it is a tightly coupled dependency of BusinessStats
// not tested for the same reason, it is tested in the snapshot of BusinessStats
function BusinessStatsItem({Icon, description, headline}: Props): ReactElement {
  return (
    <div className="businessStatsItem">
      <Icon className="businessStatsItem__icon" />
      {typeof headline === 'function' ? headline('businessStatsItem__stat') : headline}
      <Paragraph alignment={Alignment.CENTER} className="businessStatsItem__desc">
        {description}
      </Paragraph>
    </div>
  );
}

export default BusinessStatsItem;
